import { routes } from "src/shared/routes";
import { FAQS, REGISTRATION_CARDS, TERMS_AND_CONDITION_ADD_ON } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const northislandcreditunion_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "northislandcreditunion_upgrades",
  TEAM_FULL_NAME: "Live Nation North Island Credit Union",
  BROWSER_TITLE: "North Island Credit Union Ancillary",
  CLIENT_ID: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: false,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      BACKGROUND_COLOR: "#000000",
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()}`,
    },

    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/lnconcerts",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    IS_CROWD_HANDLER_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
      ATTEND_BUTTON_COLOR: "#696969",
    },

    HIDE_EVENT_BANNER: true,

    PAGE_TITLE: "Available Offers",
    HIDE_ALL_GAMES_BUTTON: true,

    ADD_ON: {
      CUSTOM_MAX_SEAT_CLAIMED_MESSAGE: "This offer is no longer available.",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  IMAGES: {
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/LiveNation%20Assets/North%20Island%20Credit%20Union/background.jpg",
    SEAT_MAP_URL:
      "https://ss-leagues.s3.amazonaws.com/LiveNation%20Assets/North%20Island%20Credit%20Union/NICUA_Premium_Seat_Map.jpg",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/LiveNation%20Assets/Coastal%20Credit%20Union-Raleigh_NC/1920%20x%20450_Light.png",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/LiveNation%20Assets/Coastal%20Credit%20Union-Raleigh_NC/375%20x%20550_Light.png",
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/LiveNation%20Assets/North%20Island%20Credit%20Union/northislandcreditunion-logo.png?width=96&height=76",
    FOOTER_LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/LiveNation%20Assets/North%20Island%20Credit%20Union/northislandcreditunion-footer-logo.png?width=96&height=76",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION_ADD_ON,
    NAV_MENU: {
      UPCOMING_EVENTS: "Available Offers",
    },
  },
};
